import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
    errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
        errorInfo: null
    };

    public static getDerivedStateFromError(e: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: e, errorInfo: null };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.setState((prevState) => ({...prevState, errorInfo }));
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div>
                    <h1>Sorry.. there was an error</h1>
                    <div>{this.state.error && this.state.error.toString()}</div>
                    <div>{this.state.errorInfo && this.state.errorInfo.componentStack}</div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;